
import React from "react";
import { cn } from "@/lib/utils";
import { useSettings } from "@/context/SettingsContext";
import { getRpgThemeClasses } from "@/lib/utils";
import ProgressPips from "@/components/journal/ProgressPips";

interface JournalEntryCardContentProps {
  stuckPoint: string | null;
  nextStepResponse: string | null;
  progress: number;
  progressMax: number;
}

const JournalEntryCardContent: React.FC<JournalEntryCardContentProps> = ({
  stuckPoint,
  nextStepResponse,
  progress,
  progressMax
}) => {
  const { darkMode, enableRpgMode } = useSettings();
  const rpgTheme = getRpgThemeClasses(enableRpgMode, darkMode);

  return (
    <>
      <div className={cn(
        "p-3 rounded-md mb-2",
        enableRpgMode ? (
          "bg-amber-900/30 border border-amber-600/30"
        ) : (
          darkMode ? "bg-[#1a0930]/30" : "bg-[#6127A0]/5"
        )
      )}>
        <p className={cn(
          "font-medium",
          enableRpgMode && rpgTheme.text
        )}>
          {stuckPoint || (enableRpgMode ? "No challenge recorded" : "No stuck point recorded")}
        </p>
      </div>
      
      <div className="mt-3 mb-2">
        <ProgressPips
          progress={progress || 0}
          maxProgress={progressMax || 7}
          readonly
          size="sm"
        />
      </div>
      
      {nextStepResponse && (
        <div className="mt-2">
          <h4 className={cn(
            "text-xs uppercase tracking-wide opacity-70 mb-1",
            enableRpgMode && rpgTheme.accent
          )}>
            {enableRpgMode ? "Path Forward:" : "Next Steps:"}
          </h4>
          <p className={cn(
            "text-sm opacity-90",
            enableRpgMode && rpgTheme.text
          )}>
            {nextStepResponse}
          </p>
        </div>
      )}
    </>
  );
};

export default JournalEntryCardContent;
